import i18n from 'i18next';

import { addToast } from 'core/notifications';

export default ({ maxFileSize, mimeType }) => {
  const maxFileSizeErrorMessage =
    typeof maxUploadSizeInMb === 'number'
      ? i18n.t('max-file-size', { maxFileSize })
      : i18n.t('max-file-size-per-mime-type', { mimeType, maxFileSize });
  addToast(maxFileSizeErrorMessage, 'error');
};
